export default "__VITE_ASSET__DSINh5Cn__"